import * as React from 'react';
import {TagDisplay} from 'src/inputs/TagInput/TagDisplay';

type Props = {
  onRemove?: (index: number) => void;
  showRemove?: boolean;
  tags: string[];
  children?: React.ReactNode;
};

const MultiTagDisplay = (props: Props) => {
  return (
    <div className="flex flex-row flex-wrap gap-2">
      {props.tags.map((tag, index) => (
        <TagDisplay
          key={tag}
          name={tag}
          onRemove={() => props.onRemove && props.onRemove(index)}
          showRemove={props.showRemove}
        />
      ))}
      {props.children}
    </div>
  );
};

export default MultiTagDisplay;
